import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { NgIf, NgStyle, NgClass } from '@angular/common'

@Component({
    selector: 'ng-progress-bar',
    templateUrl: 'progress-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgStyle, NgClass],
})
export class ProgressBarComponent {
    @Input() state: any
    @Input() positionUsing: any
    @Input() ease: any
    @Input() speed: any
    @Input() showSpinner: any
    @Input() direction!: string
    @Input() thick: any
    @Input() color: any

    /** Styles for progressbar */
    barStyles() {
        let styles = {
            transition: 'all ' + this.speed + 'ms ' + this.ease,
            backgroundColor: this.color,
        }
        /** Get positioning value */
        let n = !this.state.value
            ? {
                  leftToRightIncreased: -100,
                  leftToRightReduced: 0,
                  rightToLeftIncreased: 100,
                  rightToLeftReduced: 0,
              }[this.direction]
            : this.toPercentage(this.state.value)

        switch (this.positionUsing) {
            case 'translate3d':
                styles = Object.assign({}, styles, {
                    transform: 'translate3d(' + n + '%,0,0)',
                    '-webkit-transform': 'translate3d(' + n + '%,0,0)',
                    '-moz-transform': 'translate3d(' + n + '%,0,0)',
                    '-o-transform': 'translate3d(' + n + '%,0,0)',
                    '-ms-transform': 'translate3d(' + n + '%,0,0)',
                })
                break
            case 'translate':
                styles = Object.assign({}, styles, {
                    transform: 'translate(' + n + '%,0)',
                    '-webkit-transform': 'translate(' + n + '%,0)',
                    '-moz-transform': 'translate(' + n + '%,0)',
                    '-o-transform': 'translate(' + n + '%,0)',
                    '-ms-transform': 'translate(' + n + '%,0)',
                })
                break
            default:
                styles = Object.assign({}, styles, {
                    marginLeft: n + '%',
                })
        }
        return styles
    }

    /** Styles for progressbar tail */
    shadowStyles() {
        return {
            boxShadow: `0 0 10px ${this.color}, 0 0 5px ${this.color}`,
        }
    }

    toPercentage(n: any) {
        return (
            {
                leftToRightIncreased: -1 + n,
                leftToRightReduced: -n,
                rightToLeftIncreased: 1 - n,
                rightToLeftReduced: n,
            }[this.direction] * 100
        )
    }

    public get spinnerClasses(): string {
        return {
            leftToRightIncreased: 'clockwise',
            leftToRightReduced: 'anti-clockwise',
            rightToLeftIncreased: 'anti-clockwise',
            rightToLeftReduced: 'clockwise',
        }[this.direction] as string
    }
}
